import Flags from "@/Flags/Flags";
import { loadScript } from "@/Utils/Utils";
window[__APP_NAME__] = window[__APP_NAME__] || {
    pid: Flags.pid || 'default'
};
const pid = window[__APP_NAME__]?.pid;
if (Flags.tester) {
    loadScript({
        id: `${__APP_NAME__}_tester`,
        src: (`${__LIB_URL__}/${__APP_NAME__}-tester.min.js`).toLowerCase(),
    });
}
/**
 * generate project file name
 *  @param {string} pid
 *  @param {string} [appName]
 *  @param {string} [version]
 *  @param {TBreakpoints} [breakpoint]
 * @returns {string}
 */
const buildFileName = (pid, appName, version, breakpoint) => `${[appName, pid, breakpoint].filter(i => i).join('.')}-${version || 'latest'}.min.js`;
loadScript({
    id: __APP_NAME__,
    src: (`${__LIB_URL__}/${pid}/${buildFileName(pid, __APP_NAME__)}`).toLowerCase(),
    fallbackSrc: (`${__LIB_URL__}/default/${buildFileName('default', __APP_NAME__)}`).toLowerCase()
}).catch(() => {
    console.error(`Unable to load ${__APP_NAME__} app file.`);
});
